/**
 * @CE liweikang
 */
import React from 'react';
import { DefaultRequest } from '../requests/default.request';
import Button from '@material-ui/core/Button';
import { Input } from '@material-ui/core';
import Store from '../redux/store';

export default class CodePage extends React.Component<Props, State>{
    constructor(props: Props) {
        super(props);
        this.state = {
            tableId: '',
        }
    }

    // *********************
    // 方法区
    // *********************

    getCode = async () => {
        const HREFARR = Store.getState().localHref.split(':')
        const PORT = parseInt(HREFARR[1]);
        let table_id = parseInt(this.state.tableId);
        await DefaultRequest.getQrcode(HREFARR[0], PORT, table_id);
    }

    // *********************
    // 视图区
    // *********************

    render() {
        return (
            <div className='codeMain'>
                <span style={{ marginRight: 20 }}>请输入桌台id</span>
                <Input
                    onChange={(event) => { this.setState({ tableId: event.target.value }) }}
                    color="primary" />

                <Button variant="contained" onClick={this.getCode} color="primary" style={{ marginTop: 40 }}>
                    生成二维码
                 </Button>
            </div>
        )
    }
}

// **********
// TYPE
// **********

type Props = {

}

type State = {
    tableId: string
}